import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";

import './Brand.scss';
import MyContext from '../MyContext.jsx';

class Brand extends Component {
  constructor(props) {
    super(props);
    this.companySelect = React.createRef();
    this.state = {
      brand_name : '',
      companies : [],
      company :{},
      brand_type : 'NEW',
      categories : [],
      selected_categories : []
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){   
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getMarketingBrandDetails`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // return;
      if(return_data.status == "success"){
        obj_this.setState({
          categories : return_data.categories,
          companies : return_data.companies
        },() => {
          $(".new_marketing_brand_container").css("visibility","visible");
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.props.history.replace("/");
    });

  }

  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }

  brandTypeChange(e){
    // console.log(option);
    this.setState({
      brand_type : e.target.value
    }); 
  }

  companyChange(option){
    this.setState({
      company : option
    });
  }

  categoryChange(id) {
    let selected_categories = this.state.selected_categories
    let find = selected_categories.indexOf(id)

    if(find > -1) {
      selected_categories.splice(find, 1)
    } else {
      selected_categories.push(id)
    }

    this.setState({ selected_categories })
  }

  formSubmit(e){
    e.preventDefault();
    console.log(this.state);
    var brand_details = this.state;
    // if(!brand_details.company.value){
    //    this.companySelect.current.focus();
    //   return;
    // }

    const url = `${process.env.REACT_APP_SSS}/api/saveMarketingBrandDetails`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        brand_details : brand_details
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      // return;
      if(return_data.status == "already exist"){
        alert("Brand already exist.");
        obj_this.setState({brand_name : ''});
        obj_this.context.loading(0);
      }else if(return_data.status == "success"){
        alert("Brand inserted.");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/dashboard');
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }


  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_marketing_brand_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> New Brand</div>
          </div> 
          <form className="enquiry_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="brand_details_container blocks">
              <div className="input_label">Name of the Brand</div>
              <input className="name input custom_input"
                type="text"
                name="brand_name"
                value={this.state.brand_name}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              <div className="input_label">Company</div>
              <Select 
                options={this.state.companies}  
                value ={this.state.company}
                className="company" 
                // ref={this.companySelect}
                onChange={e => this.companyChange(e)}
                // required
              />     
              <div className="input_radio_container">
                <span>Type of Brand : </span>
                <div className="lead_type_radio_buttons">
                  <div className="label_radio_container">
                    <input type="radio" 
                      name="brand_type" 
                      value="NEW"  
                      checked={this.state.brand_type == 'NEW'} 
                      onChange={e => this.brandTypeChange(e)}
                    />
                    <div>NEW</div>
                  </div>
                  <div className="label_radio_container">
                    <input type="radio" 
                      name="brand_type" 
                      value="EXISTING"
                      checked={this.state.brand_type == 'EXISTING'} 
                      onChange={e => this.brandTypeChange(e)}
                    />
                    <div>EXISTING</div>
                  </div>
                </div>
              </div>
              <div className="input_label">Category</div>
              <div className="categories_container">
                {this.state.categories.map((item) => (
                  <div className="checkbox_label_container" key={item.id}>
                    <input type="checkbox" 
                      name="category[]" 
                      value={item.id}  
                      onChange={() => this.categoryChange(item.id)}
                      selected={this.state.selected_categories.includes(item.id)}
                    /> 
                    <div className="checkbox_label">{item.category_name}</div>
                  </div>
                ))}

              </div>

                      
            </div>

            <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Brand;
Brand.contextType = MyContext;
